module.exports = __webpack_public_path__ + "static/media/pdf.a7b3d539.svg";